import React from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { SubmitButton } from 'site-modules/write-review/components/submit-button/submit-button';
import { VehicleModule } from 'site-modules/write-review/components/vehicle-module/vehicle-module';
import { DisclaimerInfo } from 'site-modules/write-review/components/disclaimer-info/disclaimer-info';
import { AuthorDetails } from './author-details';

export function AuthorInfo({
  validationErrors,
  validate,
  fieldRef,
  onSubmit,
  vehicle,
  onUserChange = null,
  isLoading = false,
  profileData,
  isUpdateForm = false,
}) {
  return (
    <div className="author-info-step text-gray-darker">
      <h1 className="heading-2 mb-1_5">Write a Review</h1>
      <VehicleModule vehicle={vehicle} showChangeButton={false} />
      <AuthorDetails
        onUserChange={onUserChange}
        validationErrors={validationErrors}
        fieldRef={fieldRef}
        validate={validate}
        profileData={profileData}
        isUpdateForm={isUpdateForm}
      />
      <SubmitButton
        onClick={onSubmit}
        validate={validate}
        isLoading={isLoading}
        isUpdateForm={isUpdateForm}
        dataTrackingId="wr_submit_step_2"
      />
      <DisclaimerInfo />
    </div>
  );
}

AuthorInfo.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fieldRef: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  validationErrors: PropTypes.shape({}).isRequired,
  profileData: PropTypes.shape({
    email: PropTypes.string,
    displayName: PropTypes.string,
    isAuthenticated: PropTypes.bool,
  }).isRequired,
  onUserChange: PropTypes.func,
  isLoading: PropTypes.bool,
  isUpdateForm: PropTypes.bool,
};
